import ModalRequest from '../../components/ModalRequest'
import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
} from '@mui/material'
import { useForm } from 'react-hook-form'
import { useCallback, useEffect, useState } from 'react'
import axiosInstance from '../../config/axiosConfig'
import { urlConfig } from '../../config/apiConfig'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { useAuth } from '../../hook/useAuth'

export default function ADD_USER({ open, setOpen, handleAlert, getUserByKey }) {
    const [site, setSite] = useState('')
    const [role, setRole] = useState('')

    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState('Inactive')
    const { handleSubmit, setValue, watch } = useForm()
    const { auth } = useAuth()

    const myLevel = auth?.role_level || 0

    const onSubmit = async (data) => {
        if (data.password !== data.confirmPassword) {
            alert('Passwords do not match!')
            return
        }
        let body = {
            ...data,
            verified_account: !!data.verified_account,
            status: status,
            expire_date: dayjs(data.expire_date, 'DD/MM/YYYY').format(
                'YYYY-MM-DD',
            ),
        }
        delete body.confirmPassword

        try {
            setLoading(true)
            await axiosInstance.post(urlConfig.user, body)
            handleAlert('User added successfully.', 'success')
            getUserByKey()
            setOpen(false)
        } catch (err) {
            handleAlert(
                `${err.response.data.message || 'No Internet'}`,
                'error',
            )
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (name, value) => {
        setValue(name, value)
    }

    const handleStatusChange = (newStatus) => {
        setStatus(newStatus ? 'Active' : 'Inactive')
        handleChange('status', newStatus)
    }

    const password = watch('password')
    const confirmPassword = watch('confirmPassword')
    const expire_date = watch('expire_date')

    const getSite = useCallback(async () => {
        try {
            const res = await axiosInstance.get(`${urlConfig.organization}`)
            setSite(res.data.message)
        } catch (error) {
            // handle error
        }
    }, [setSite])

    useEffect(() => {
        getSite()
    }, [getSite])

    const getRole = useCallback(async () => {
        try {
            const res = await axiosInstance.get(urlConfig.role)
            if (!res.data.message[0]) return
            const filteredRoles = res.data?.message?.filter(
                (item) => item.level <= myLevel,
            )
            setRole(filteredRoles)
        } catch (error) {}
    }, [setRole])

    useEffect(() => {
        getRole()
    }, [getRole])

    useEffect(() => {
        if (open === false) {
            getUserByKey() // เรียกใช้ฟังก์ชันเพื่อโหลดข้อมูลใหม่หลังจากปิด modal
        }
    }, [open, getUserByKey])

    return (
        <>
            <ModalRequest
                open={open}
                disabled={loading}
                setOpen={setOpen}
                title={`Add New User`}
                onSubmit={handleSubmit(onSubmit)}
            >
                <Grid container spacing={2} p={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            size='small'
                            label='Username'
                            required
                            name='Username'
                            onChange={(e) =>
                                handleChange('username', e.target.value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label='Password'
                            size='small'
                            type={'password'}
                            required
                            name='Password'
                            onChange={(e) =>
                                handleChange('password', e.target.value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label='Confirm Password'
                            size='small'
                            type={'password'}
                            required
                            name='Confirm Password'
                            onChange={(e) =>
                                handleChange('confirmPassword', e.target.value)
                            }
                        />
                        {password &&
                            confirmPassword &&
                            password !== confirmPassword && (
                                <p style={{ color: 'red', fontSize: '14px' }}>
                                    Passwords do not match!
                                </p>
                            )}
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl
                            fullWidth
                            size='small'
                            sx={{
                                height: '35px',
                                // borderRadius: '10px',
                            }}
                        >
                            <InputLabel id='demo-simple-select-label'>
                                Group
                            </InputLabel>
                            <Select
                                label='Group'
                                id='Group'
                                required
                                onChange={(e) =>
                                    handleChange('group', e.target.value)
                                }
                                defaultValue={
                                    watch('group') ? watch('group') : ''
                                }
                            >
                                <MenuItem value={'User'}>User</MenuItem>
                                <MenuItem value={'Admin'}>Admin</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    {watch('group') && (
                        <Grid item xs={12}>
                            <FormControl
                                fullWidth
                                size='small'
                                sx={{
                                    height: '35px',
                                    // borderRadius: '10px',
                                }}
                            >
                                <InputLabel id='demo-simple-select-label'>
                                    Role
                                </InputLabel>
                                <Select
                                    label='Role'
                                    id='Role'
                                    required
                                    onChange={(e) =>
                                        handleChange('role_id', e.target.value)
                                    }
                                    defaultValue={''}
                                >
                                    <MenuItem value={''}>-</MenuItem>
                                    {role &&
                                        role
                                            .filter(
                                                (item) =>
                                                    item.group ===
                                                    watch('group'),
                                            )
                                            .map((item, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={item.role_id}
                                                >
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <FormControl
                            fullWidth
                            size='small'
                            sx={{
                                height: '35px',
                                // borderRadius: '10px',
                            }}
                        >
                            <InputLabel id='demo-simple-select-label'>
                                Organization
                            </InputLabel>
                            <Select
                                label='Organization'
                                id='Role'
                                required
                                onChange={(e) =>
                                    handleChange('keyName', e.target.value)
                                }
                                defaultValue={''}
                            >
                                {/* <MenuItem value={''}>-</MenuItem> */}
                                {site &&
                                    site.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            value={item.keyName}
                                        >
                                            {item.site_name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label='First name'
                            size='small'
                            required
                            name='FirstName'
                            onChange={(e) =>
                                handleChange('first_name', e.target.value)
                            }
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label='Last name'
                            size='small'
                            required
                            name='LastName'
                            onChange={(e) =>
                                handleChange('last_name', e.target.value)
                            }
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label='Email'
                            size='small'
                            required
                            type='email'
                            name='Email'
                            onChange={(e) =>
                                handleChange('email', e.target.value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label='Phone number'
                            size='small'
                            required
                            name='Phone number'
                            onChange={(e) =>
                                handleChange('phone_number', e.target.value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {/* <TextField
                        fullWidth
                        label='Expire Date'
                        size='small'
                        required
                        name='expire_date'
                        type='date'
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={(e) =>
                            handleChange('expire_date', e.target.value)
                        }
                    /> */}
                        <DatePicker
                            name='expire_date'
                            label='Expire Date'
                            InputLabelProps={{ shrink: true }}
                            slotProps={{ textField: { size: 'small' } }}
                            format='DD/MM/YYYY'
                            value={expire_date}
                            onChange={(date) =>
                                setValue('expire_date', date ? date : '')
                            }
                            sx={{ width: '100%' }}
                        />
                    </Grid>
                    <Grid item xs={12} align='right'>
                        <Box>
                            <label>Active</label>
                            <Switch
                                checked={status === 'Active'}
                                color='success'
                                onChange={(e, nv) => handleStatusChange(nv)}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </ModalRequest>
        </>
    )
}
